export const paymentProfilesPerPageInitial = 20;
